import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from '@/components/ui/sonner';

import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import CookieConsent from '@/components/CookieConsent';
import Login from '@/pages/Login';
import Signup from '@/pages/Signup';
import AuthCallback from '@/pages/AuthCallback';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import Dashboard from '@/pages/Dashboard';
import TripDetail from '@/pages/TripDetail';
import InvitePage from '@/pages/InvitePage';
import Premium from '@/pages/Premium';
import { PrivacyPolicy, Terms } from '@/pages/LegalPages';

function AppRouter() {
    const location = useLocation();
    // Synchronously detect OAuth callback (must run before ProtectedRoute /me check)
    if (location.hash?.includes('session_id=')) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/premium" element={<Premium />} />
            <Route
                path="/dashboard"
                element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
            />
            <Route
                path="/trips/:tripId"
                element={<ProtectedRoute><TripDetail /></ProtectedRoute>}
            />
            <Route
                path="/join/:inviteCode"
                element={<InvitePage />}
            />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <CookieConsent />
                    <Toaster
                        position="top-right"
                        toastOptions={{
                            style: {
                                borderRadius: '14px',
                                border: '1px solid var(--ns-border)',
                                background: 'white',
                                color: 'var(--ns-text)',
                                fontFamily: 'Manrope, sans-serif',
                            },
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
